import appConfig from 'app-config';

import metadata from './MLDriverDiscoveryReviewTablePopup.metadata.json5';
import styles from './MLDriverDiscoveryReviewTablePopup.module.scss';
import { useCallback, useContext, useState } from 'react';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';

import { IntlContext } from '@jutro/legacy/locale';

const MLDriverDiscoveryReviewTablePopup = (props) => {
    const {
        submissionVM,
        updateWizardData,
        discoveredDrivers,
        nonDiscoveredDrivers,
        onCancel,
        viewModelService,
        saveToEndorsement
    } = props;
    // 
    const [drivers, setDrivers] = useState(discoveredDrivers);
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value",false);
       
    const isGPA = appConfig.portalCode === 'GPA';
    const isAMP = appConfig.portalCode === 'AMP';
    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const genderTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('GenderType');
    const statusTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('DriverStatusType_ML');
    const maritalStatusTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('MaritalStatus');

    const getFormattedDateString = useCallback((gwDateVal) => {
        const date = LocalDateUtil.toMidnightDate(gwDateVal);
        return intl.formatDate(date, { year: 'numeric', month: '2-digit', day: '2-digit' });
    }, [intl]);

    const handleDriverDiscoveryReviewData = () => {
        const ddrDrivers = [...drivers, ...nonDiscoveredDrivers];
        _.set(submissionVM, 'lobData.personalAuto.coverables.prefillDrivers.value', ddrDrivers);
        updateWizardData(submissionVM);
        onCancel();
        saveToEndorsement().then(() => {});
    }

    const getDriverStatusValueType = (index) => {
        return (drivers[index].nonDriverReason !== undefined) ? drivers[index].nonDriverReason : "discovered";
    };
    
    const getDriverMaritalStatusValueType = (index) => {
        return (drivers[index].maritalStatus_ML !== undefined) ? drivers[index].maritalStatus_ML : "";
    };

    const handleDriverSelect = (val, index) => {
        const value = val ? val : 'discovered';
        setDrivers(drivers.map((driver, i) => (i === index ? { ...driver, nonDriverReason: value} : driver)));
    };

      const handleMaritalStatus = (val, index) => {
        const value = val ? val : '';
        setDrivers(drivers.map((driver, i) => (i === index ? { ...driver, maritalStatus_ML: value} : driver)));
    };


    const getReasons = () => {
        return [
            "own_insurance", "never_licensed", "abroad", "deceased", 
            "mission", "permit", "unknown", "discovered", 
            "license_revoked", "unwanted", "not_household", "duplicate_driver_ml"
        ];
    };
       const  getMaritalStatus = () => {
        return [
            "C", "D", "M", "P","S","U","V"        
        ];
    };

    const getDriverStatusTypeOptions = () => {
        let codes = statusTypeList.codes.filter((status) => _.includes(getReasons(), status.code));
        return codes.map((option) => {
            return {
                code: option.code,
                name: translator({
                    id: option.name,
                    defaultMessage: option.name
                })
            };
        });
    };

  
     const getMaritalStatusOptions = (item) => {
       let codes = maritalStatusTypelist.codes.filter((status) =>
         _.includes(getMaritalStatus(), status.code),
       );

       return codes.map((option) => {
         return {
           code: option.code,
           name: translator({
             id: option.name,
             defaultMessage: option.name,
           }),
         };
       });
     };
        

    const isRenewed = (driver) => {
        if(driver.hasOwnProperty('discoveredDriverProcessed') && driver.discoveredDriverProcessed === true) {
            return true
        }
        return false
    }

    const generateDriverOverrides = () => {
        if (drivers) {
            const getTypeKeyDescription = (typeKeyName) => {
                return translator({
                    id: typeKeyName,
                    defaultMessage: typeKeyName
                });
            };
            const overrides = drivers?.map((driver, index) => {
                return {
                    [`nameCell${index}`]: {
                        content: _.startCase(_.toLower(driver.displayName))
                    },
                    [`dobCell${index}`]: {
                        content: driver.dateOfBirth ? getFormattedDateString(driver.dateOfBirth) : ''
                    },
                    [`genderCell${index}`]: {
                        content: driver.gender ? getTypeKeyDescription(genderTypeList.getCode(driver.gender).name) : ''
                    },
                    [`nonDriverReasonCell${index}`]: {
                        availableValues: getDriverStatusTypeOptions(),
                        value: getDriverStatusValueType(index),
                        disabled: isRenewed(driver),
                        onValueChange: (value) => {
                            handleDriverSelect(value, index);
                        }
                    },
                      [`maritalStatusCell${index}`]: {
                        visible:isModernProduct && driver.status_ML==="own_insurance",
                        availableValues: getMaritalStatusOptions(),                       
                        value: getDriverMaritalStatusValueType(index),
                        disabled: isRenewed(driver),
                        onValueChange: (value) => {
                            handleMaritalStatus(value, index);
                        }
                    },
                };
            });
            return Object.assign({}, ...overrides);
        }
        return {};
    };

    const overrides = {
        contentContainer: {
            className: isAMP ? 'amp-ml-driver-table-popup' : 'ml-driver-table-popup'
        },
        driverDiscoveryTableContainer: {
            visible: true
        },
        driverDiscoveryTable: {
            visible: !_.isEmpty(drivers) && drivers?.length > 0 
        },
        driverDiscoveryIterable: {
            data: drivers
        },
        footer: {
            visible: !_.isEmpty(drivers) && drivers?.length > 0,
            className: isAMP ? 'footer amp-footer-padding col-md-12' : 'footer col-md-12'
        },

        ...generateDriverOverrides()
    };

    const resolvers = {
        resolveCallbackMap : {
            onContinue: () => { handleDriverDiscoveryReviewData()}
        },
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
};

MLDriverDiscoveryReviewTablePopup.propTypes = {};

export default MLDriverDiscoveryReviewTablePopup;